module.exports = __webpack_public_path__ + "static/media/ChromecastConnectingStep1Icon.1fe420b4.svg";